export const InitialState = {
  configurationAccount: "",
  refreshToken: "",
  grantUrl: "",
  principalAccountName: "Cayosoft Forest Recovery",
  consentError: "",
  azureError: "",
  createError: "",

  subscription: {
    subscriptionId: "",
    name: "",
  },

  selectedFlow: "default" as "default" | "applicationCertificate",
  applicationId: "",
  tenantId: "",
  certificate: "",
  certificateFileName: "",
  certificatePassword: "",
  certificateError: "",
  subscriptionsError: "",
  subscriptionLoadTrigger: 0,
};

export const wizardStateReducer = (state: any, action: any) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
